import { FeatureSources } from '../../enums';

// as more types become linkable, we can add them here.
const linkableEvidenceTypes: Set<string> = new Set([
  FeatureSources.NOTE,
  FeatureSources.NOTE_CONVERTED,
  FeatureSources.REASON_FOR_VISIT,
  FeatureSources.PROCEDURE_TYPE,
  FeatureSources.EXAM_DESCRIPTION
  // FeatureSources.EXAM_TYPE,
  // FeatureSources.BODY_REGION,
  // FeatureSources.PROCEDURE_CATEGORY
]);

// ----------------------------------
// sort
// ----------------------------------
const sortValues = {
  CODED: 5,
  SUBMITTED: 10,
  PROCESSED: 20,
  ASSEMBLED: 30,
  MAPPED: 40,
  PREDICTION: 50,
  REFERRAL: 60,
  REMITTANCE: 70,
  CLINICAL: 100,
  CLAIM: 110
};

const MAX_VAL = 1000;

const comparator = (
  artifactA: CMxAPI.CaseArtifacts | CMxCommonApp.SimplifiedInvoice,
  artifactB: CMxAPI.CaseArtifacts | CMxCommonApp.SimplifiedInvoice
) => {
  const valA = sortValues[artifactA.type] || MAX_VAL;
  const valB = sortValues[artifactB.type] || MAX_VAL;

  if (valA < valB) {
    return -1;
  }
  if (valA > valB) {
    return 1;
  }
  // a must be equal to b
  return 0;
};

// ----------------------------------
// displayable
// ----------------------------------

const isDisplayable = (
  artifactSet: Set<string>,
  artifact: CMxAPI.CaseArtifacts
) => artifactSet.has(artifact.type);

export const artifactsForDisplay = (
  artifactList: CMxAPI.CaseArtifacts[],
  artifactSet: Set<string>
): CMxAPI.CaseArtifacts[] => {
  const filtered = artifactList.filter(artifact =>
    isDisplayable(artifactSet, artifact)
  );
  const sorted = filtered.sort(comparator);
  return sorted;
};

const OWN_META: CMxArtifacts.ArtifactMetaData = {
  imported: false,
  ownerCaseId: null,
  description: 'These codes originated in your system'
};

const LINKED_META: CMxArtifacts.ArtifactMetaData = {
  imported: true,
  ownerCaseId: null,
  description: 'These codes come from a different case'
};

type ArtifactFilterArgs = {
  caseRun: CMxAPI.CaseRun;
  artifactSet: Set<string>;
  importedCaseRun?: CMxAPI.CaseRun;
  importedSet?: Set<string>;
};

export const filterAndAssembleArtifactList = ({
  caseRun,
  artifactSet,
  importedCaseRun,
  importedSet
}: ArtifactFilterArgs) => {
  let artifacts = artifactsForDisplay(
    caseRun.artifacts ?? [],
    artifactSet
  ).flat();

  let own = artifacts.map(artifact => ({
    ...artifact,
    meta: { ...OWN_META }
  }));

  if (importedCaseRun && importedSet) {
    const alternates = artifactsForDisplay(
      importedCaseRun?.artifacts ?? [],
      importedSet
    ).flat();

    const meta = {
      ...LINKED_META,
      ownerCaseId: importedCaseRun.case_id,
      description: `${
        importedCaseRun.exam_description
      } - Acc #: ${importedCaseRun.primary_clinical_identifier?.number ??
        'N/A'} (${importedCaseRun.primary_clinical_identifier?.issuer ??
        'N/A'})`
    };
    const linked = alternates
      .map(artifact => ({
        ...artifact,
        meta
      }))
      .flat();
    return [...own, ...linked];
  }
  return [...own];
};

// ----------------------------------
// linkable
// ----------------------------------
export const isLinkable = (evidenceKey: string) => {
  return linkableEvidenceTypes.has(evidenceKey);
};

export const sortInvoices = comparator;
